import React, { useState } from 'react'
import { Button, Checkbox, Form, Input } from 'antd';
import './Login.scss'
import LandService from '../../../service/LandService';
import UserService from '../../../service/UserService';

const Login = ({setToken}) => {
    const [isLoginFail, setIsLoginFail] = useState(false)

    const login = (data) => {
    (async () => {
      try {
        const response = await UserService.login(data);
        if(response == undefined){
            setIsLoginFail(true)
        }
        else{
            localStorage.setItem('token', response.data.result.token);
            console.log("set token ", response)
            setToken(response.token);
        }
      } catch (error) {
        console.log('Failed to login', error);
      }
    })();
  }

    const onFinish = values => {
        login(values)
    };
    const onFinishFailed = errorInfo => {
        console.log('Failed:', errorInfo);
    };

    return (
        <div class="login-container">
            

            <div class="logo">BĐS Thanh Oai</div>

            <h2>Đăng nhập để quản lý thông tin</h2>

            <Form
                name="basic"
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 24 }}
                style={{ maxWidth: 600 }}
                initialValues={{ remember: true }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                layout='vertical'
                autoComplete="off"
            >
                <Form.Item
                    label="Username"
                    name="username"
                    rules={[{ required: true, message: 'Chưa nhập tài khoản!' }]}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    label="Password"
                    name="password"
                    rules={[{ required: true, message: 'Chưa nhập mật khẩu!' }]}
                >
                    <Input.Password />
                </Form.Item>

                {isLoginFail && <div className='error-login'>Thông tin đăng nhập không chính xác!</div>}

                <Form.Item>
                    <Button type="primary" htmlType="submit" style={{width: 200, height: 40, marginTop: 10}}>
                        Đăng nhập
                    </Button>
                </Form.Item>
            </Form>

            {/* <div class="footer">
                © 2026 Your Company
            </div> */}
        </div>
    )
}

export default Login